import GroupService from "../../Api/GroupService";
import {GET_GROUPS_SUCCESS} from "./types";

export const getGroupsAction = () => async (dispatch) => {
    try {
        const data = await GroupService.getAll();

        dispatch({type: GET_GROUPS_SUCCESS, payload: data})

    } catch (err) {
        //dispatch(getError(err.response.data));
        console.log(err)
    }
};


